import { FC } from 'react'
import WriteUs from './write-us-popup/write-us'
import WriteUsBtn from './write-us-btn/write-us-btn'
import useToggle from 'hooks/useToggle'
import styles from './write-us-block.module.scss'

const WriteUsBlock: FC = () => {
  const [feedBackOpened, toggleFeedback] = useToggle()

  return (
    <div className={styles.writeUsWrap}>
      <h3 className={styles.title}>Остались вопросы?</h3>
      <WriteUsBtn handler={toggleFeedback} />
      <WriteUs toggleFeedback={feedBackOpened} setToggleFeedback={toggleFeedback} />
    </div>
  )
}

export default WriteUsBlock
